"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ItemForm;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _NavTabs = _interopRequireDefault(require("../NavTabs"));
var _PageTitle = _interopRequireDefault(require("../PageTitle"));
function ItemForm(_ref) {
  var actions = _ref.actions,
    afterTitleComponents = _ref.afterTitleComponents,
    _ref$back = _ref.back,
    back = _ref$back === void 0 ? true : _ref$back,
    children = _ref.children,
    disabled = _ref.disabled,
    form = _ref.form,
    handleSubmit = _ref.handleSubmit,
    hideSave = _ref.hideSave,
    id = _ref.id,
    isNew = _ref.isNew,
    saveButtonTranslationKey = _ref.saveButtonTranslationKey,
    SaveButtonProps = _ref.SaveButtonProps,
    submitting = _ref.submitting,
    subtitle = _ref.subtitle,
    tabs = _ref.tabs,
    title = _ref.title,
    viewId = _ref.viewId,
    tabProps = _ref.tabProps;
  return /*#__PURE__*/_react.default.createElement("form", {
    form: form,
    id: id,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_PageTitle.default, {
    actions: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, actions, !hideSave && !disabled && /*#__PURE__*/_react.default.createElement(_material.Button, (0, _extends2.default)({
      color: "primary",
      disabled: submitting,
      id: "".concat(id, "SaveButton"),
      type: "submit",
      variant: "contained"
    }, SaveButtonProps), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: saveButtonTranslationKey || 'actions.save'
    }))),
    afterTitleComponents: afterTitleComponents,
    back: back,
    id: "".concat(id, "PageTitle"),
    subtitle: subtitle,
    title: title,
    titleKey: isNew ? "".concat(form, ".new") : "".concat(form, ".item")
  }), tabs && /*#__PURE__*/_react.default.createElement(_NavTabs.default, {
    id: id,
    tabProps: tabProps,
    tabs: tabs,
    value: viewId
  }), children);
}